<script setup lang="ts"></script>

<template>
  <dl :class="$style.definitionListSection">
    <slot></slot>
  </dl>
</template>

<style lang="scss" module>
@use '_constants.scss' as *;
.definitionListSection {
  padding: 16px 24px;
  border: 2px solid $color-border-medium-emphasis;
  margin: 1em 0;
  line-height: 1.8;

  @media only screen and (max-width: 1024px) {
    padding: 12px 16px;
  }

  dt {
    font-weight: bold;
  }

  dd {
    ul {
      margin-left: 1.5em;
      list-style-type: disc;
    }

    dl {
      margin-left: 1.5em;
    }

    ol {
      margin-left: 1.5em;
      list-style-type: decimal;

      & .steps {
        list-style-type: none;
      }
    }

    p {
      margin-bottom: 0 !important;
    }
  }
}
</style>
